import {
    styled,
    StyledAccordion,
    StyledButton,
} from '@raskrask-dk/rr-components'

export const StyledPickButtons = styled('div', {
    display: 'grid',
    gap: '$2',
    gridAutoFlow: 'dense',
    gridTemplateColumns: 'repeat(auto-fit, minmax(50px, 1fr))',
})

export const StyledCompanyCard = styled('div', {
    [`& ${StyledButton}`]: {
        px: '$1',
    },

    variants: {
        isOpen: {
            true: {
                [`& ${StyledAccordion}`]: {
                    overflow: 'visible',
                },
            },
        },
    },
})
